import { createContext, createElement } from 'react'

import { useEditAudioModal } from './_hooks/useEditAudioModal'
import { useYoutubeLinkModal } from './_hooks/useYoutubeLinkModal'
import { useHistoryModal } from './_hooks/useHistoryModal'

import type { ReactNode } from 'react'

import { useSiteSpecificContext } from '@/contexts/SiteSpecificContext'


import { useContext } from 'react';
function useGeneratorForm() {
  const editAudioModal = useEditAudioModal()
  const youtubeLinkModal = useYoutubeLinkModal()
  const historyModal = useHistoryModal()
  const { plan } = useSiteSpecificContext()
  const { hasActivePlan } = plan

  return {
    editAudioModal,
    youtubeLinkModal,
    historyModal,
    hasActivePlan,
  }
}

const GeneratorFormContext = createContext<ReturnType<typeof useGeneratorForm>>(
  null!,
)

export const GeneratorFormProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const value = useGeneratorForm()

  return createElement(
    GeneratorFormContext.Provider,
    {
      value,
    },
    children,
  )
}

export const useGeneratorFormContext = () => {
  const context = useContext(GeneratorFormContext)
  if (!context) {
    throw new Error(
      'useGeneratorFormContext must be used within a GeneratorFormProvider',
    )
  }
  return context
}
